<template>

  <div class="rating-holidaycheck" v-if="$attrs.rating.count !== '0'">
    <a :href="$attrs.rating.url" target="_blank" title="Bewertungen zu {title} auf HolidayCheck ansehen">
      <img v-bind:src="staticHCLogo"/>

      <div class="mobile-version">
        <div class="rating-detail">
          <p class="rating-number">
            <span class="rating-percent">{{$attrs.rating.percent}}%</span>
            <span class="rating-count">({{$attrs.rating.count}})</span>
          </p>
          <p class="rating-text">Weiterempfehlung</p>
        </div>
      </div>

      <div class="desktop-version">
        <div class="rating-detail">
          <span class="rating-percent">{{$attrs.rating.percent}}%</span>
          <p class="rating-text">Weiterempfehlung</p>
        </div>

        <div class="rating-detail">
          <span class="rating-percent">{{$attrs.rating.count}}</span>
          <p class="rating-text">Bewertungen</p>
        </div>
      </div>

    </a>
  </div>

</template>

<script>


export default {
  name: 'Rating',
  data() {
    return {}
  },
  computed: {
    staticHCLogo() {
      return mediathekPublicAssetsPath + 'Logos/holidaycheck-logo.png';
    },
  },
  components: {},
  methods: {}
}
</script>

<style lang="scss">
</style>